import React from 'react';
import Viewer from '../Manage/Content/Viewer';

const Index = () => {
  return (        
        <Viewer url={process.env.REACT_APP_HOME_PAGE_KEY} showSkeleton={true}/>
    )
}
export default Index;